import type { SyncRouter } from "./types";

let router: SyncRouter;

export function setRouter(routerImpl: SyncRouter) {
  router = routerImpl;
}

export function getRouter() {
  return router;
}
